import { Toaster } from 'react-hot-toast';

export const ToastProvider = () => {
  return (
    <Toaster
      position="top-center"
      toastOptions={{
        duration: 4000,
        style: {
          background: '#1F2937', // Dark Gray (Cards)
          color: '#FFFFFF',      // White
          border: '1px solid #374151', // Gray Border
        },
        success: {
          iconTheme: {
            primary: '#10B981', // Success Green
            secondary: '#FFFFFF',
          },
        },
        error: {
          iconTheme: {
            primary: '#EF4444', // Error Red
            secondary: '#FFFFFF',
          },
        },
      }}
    />
  );
};